import React from 'react';

import { Box } from '@mui/material';

export const lockInfoMenuId = 'lock-info-edit-modal-container';

const menuContainerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  paddingRight: '24px',
};

const LockInfoAdditionalInfo = () => {
  return <Box id={lockInfoMenuId} sx={menuContainerStyles} />;
};

export default LockInfoAdditionalInfo;
